import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { LoginStatusMessage } from '@/LoginStatusMessage'
import { LoginButton, Container } from './components/styles'

export interface LoginOauthProps {
  onLoginButtonClick: () => void
  showButton: boolean
}

export function LoginOauth({ onLoginButtonClick, showButton }: LoginOauthProps) {
  const intl = useIntl()

  return (
    <OauthContainer>
      {showButton ? (
        <LoginGroupContainer>
          <Title>{intl.messages[`app.login_screen.title`] as unknown as string}</Title>
          <Subtitle>{intl.messages[`app.login_screen.subtitle`] as unknown as string}</Subtitle>
          <LoginButtonStyled onClick={onLoginButtonClick}>{intl.messages[`app.login_screen.btn`] as unknown as string}</LoginButtonStyled>
        </LoginGroupContainer>
      ) : (
        <LoginStatusMessage status="auth" />
      )}
    </OauthContainer>
  )
}

const OauthContainer = styled(Container)`
  ${LoginButton} {
    margin: auto;
    max-width: 468px;
  }
`

const Title = styled.span`
  margin-top: auto;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin-bottom: 8px;
`

const Subtitle = styled.span`
  font-size: 14px;
  color: #8e8f98;
  width: 100%;
  text-align: center;
  margin-bottom: 32px;
`

const LoginButtonStyled = styled(LoginButton)`
  margin: 0;
`

const LoginGroupContainer = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${LoginButtonStyled} {
    margin: 0;
    align-self: center;
  }
`
